<script lang="ts">
    import type { Snippet } from "svelte";

    let {
        tip,
        position = "top",
        class: className = "",
        children,
    }: {
        tip: string;
        position?: "top" | "bottom" | "left" | "right";
        class?: string;
        children: Snippet;
    } = $props();
</script>

<div
    class="tooltip tooltip-styled tooltip-{position} {className}"
    data-tip={tip}
    style="--tt-bg: var(--color-base-300);"
>
    {@render children()}
</div>

<style>
    :global(.tooltip-styled)::before {
        outline: 1px solid color-mix(in oklab, currentColor 20%, transparent) !important;
    }
</style>
